import { Routes } from '@angular/router';

export const routes: Routes = [

	{
		path: '',
		loadChildren: () =>
			import('@webapp/auth/routes').then(
				m => m.authenticationRoutes
			),
	},

];
